import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Transition, Dimmer, Loader, Message } from 'semantic-ui-react';
import { setUserSubscriptionLevelByCode } from '@emyw/subscribe-lib/utils';
import { log } from '@emyw/core-lib';
import Step2Intro from '@emyw/subscribe-lib/Step2Intro';
import { ValidateStep, subscriptionProgress } from './index';
import { loadUser } from '../actions/userActions';
import { withAppContext } from '../AppContext';

const { REACT_APP_TOKEN_NAME, REACT_APP_REFRESH_TOKEN_NAME } = process.env;

class SetupAccount extends Component {
    state = {
        proceedTo: undefined,
        processing: false,
        error: undefined,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user, disableSocialLogin/* , currentStep */ } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            // disable setupaccount where they can choose to signup using facebook or google+
            // prefer them to have a username and password for better login options in the native apps
            if (directTo === 'setupaccount' && disableSocialLogin) {
                // If directTo equals 'setupaccount' (current page), then there's no need to go back to the plan page, so forward to newaccount
                // if (currentStep === 'account') {
                //     this.setNextLocation('plan');
                // } else {
                this.setNextLocation('newaccount');
                // }
            }
            if (directTo === 'setupaccount') return;
            const { skipPlanSelect } = context.state;
            if (directTo === 'plan' && skipPlanSelect) return;
            this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'account' });
    }

    setNextLocation = (pathname) => {
        localStorage.setItem('enjoy-signup-progress', pathname);
        this.setState({ proceedTo: pathname });
    }

    setUserNextLocation = (user) => {
        const progress = subscriptionProgress(user);

        /** Now that we are logged in, we can remove some of the storage we were holding onto,
         * but make sure to get subscriptionProgress before deleting 'plan-code'
         * */
        sessionStorage.removeItem('user-form-values');
        sessionStorage.removeItem('social-user');
        localStorage.removeItem('verification-email');
        localStorage.removeItem('enjoy-signup-progress');
        localStorage.removeItem('plan-code');

        if (user.signupCompletedOn) {
            this.setState({ proceedTo: '/' });
        } else {
            this.setState({ proceedTo: progress });
        }
    }

    handleContinueClick = () => {
        this.setNextLocation('newaccount');
    };

    updateSubscriptionLevel = async (userId, planCode) => {
        try {
            const result = await setUserSubscriptionLevelByCode(userId, planCode);
            const { ok, errors } = result;
            log.trace('response:', result);
            if (ok) {
                return true;
            }
            this.setState({ error: errors[0].message, processing: false });
            return false;
        } catch (error) {
            log.trace(error);
            this.setState({ error: error.message, processing: false });
        }
        return false;
    };

    handleSocialLoginSuccess = async (socialUser, needsEmail) => {
        const { context } = this.props;
        const storedCode = localStorage.getItem('plan-code');
        sessionStorage.setItem('social-user', JSON.stringify(socialUser));
        // log.trace('socialUser', socialUser, 'needsEmail', needsEmail);
        if (needsEmail) {
            this.setNextLocation('newaccount');
        } else {
            loadUser('network-only')(async ({ user }) => {
                if (user) {
                    if (!user.subscriptionLevelCode && storedCode) {
                        const ok = await this.updateSubscriptionLevel(user.userId, storedCode);
                        if (ok) {
                            loadUser('network-only')(({ user: userNew }) => {
                                context.setAppState({ user: userNew });
                                this.setUserNextLocation(userNew);
                            });
                        }
                    } else {
                        context.setAppState({ user });
                        this.setUserNextLocation(user);
                    }
                } else {
                    /* Social login failed. Remove any tokens it created and set state error */
                    sessionStorage.removeItem(REACT_APP_TOKEN_NAME);
                    sessionStorage.removeItem(REACT_APP_REFRESH_TOKEN_NAME);
                    this.setState({ error: 'Social login failed. Please try again or select CONTINUE to create an account.' });
                }
            });
        }
    }

    handleFailure = (error) => {
        log.trace(error);
    };

    render() {
        const { proceedTo, processing, error } = this.state;
        if (proceedTo) return <Redirect push to={`/${proceedTo === '/' ? '' : `signup/${proceedTo}`}`} />;
        const planCode = localStorage.getItem('plan-code');

        return (
            <div style={{ margin: '0 auto' }}>
                <Helmet>
                    <title>Enjoy Signup - Account Setup</title>
                    <meta name="description" content="Account setup" />
                </Helmet>
                {processing && (
                    <Transition visible={processing} animation="scale" duration={500}>
                        <Dimmer active/*  inverted */>
                            {/* eslint-disable-next-line react/jsx-tag-spacing */}
                            <Loader /* inverted */>One Moment...</Loader>
                        </Dimmer>
                    </Transition>
                )}
                <Step2Intro
                    onSocialLoginFailure={this.handleFailure}
                    onSocialLogin={this.handleSocialLoginSuccess}
                    onContinueClick={this.handleContinueClick}
                    planCode={planCode}
                />
                {error && (
                    <div
                        /* Match subscribe lib's width restraint: */
                        className="wizardStepBase"
                        style={{ margin: '0 auto' }}
                    >
                        <Message
                            size="small"
                            error
                            header="Trouble with registration form..."
                            content={error}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default withAppContext(SetupAccount);
